import { action, makeObservable, observable } from 'mobx';

const getOrientation = () => {
  if (window.matchMedia('(orientation: portrait)').matches) {
    return 'portrait';
  } else if (window.matchMedia('(orientation: landscape)').matches) {
    return 'landscape';
  }
};

const isMobile = () => {
  const lIsMobile =
    /Mobi|Android|iPhone|iPod/i.test(navigator.userAgent) ||
    window.innerWidth < 600;
  return lIsMobile;
};

const isTablet = () => {
  // console.log('isTablet', window.innerWidth);
  // console.log('orientation', getOrientation());
  const lIsTablet =
    /iPad|Tablet/i.test(navigator.userAgent) ||
    (window.innerWidth >= 600 && window.innerWidth < 1380);
  return lIsTablet;
};

const getDeviceType = () => {
  const lIsLandscape = getOrientation() === 'landscape';

  let currentDeviceType = 'desktop';
  //Tablets in portrait mode are considered mobile (Exceptions made for large tablets like iPad pro)
  //Large enough mobiles in landscape are considered tablets
  if (
    (isTablet() && window.innerWidth < 850) ||
    (isMobile() && !lIsLandscape)
  ) {
    currentDeviceType = 'mobile';
  } else if (isTablet() || (isMobile() && lIsLandscape)) {
    currentDeviceType = 'tablet';
  }

  let currentDevice = {
    device: currentDeviceType,
    orientation: isTablet() || isMobile() ? getOrientation() : null,
  };

  return currentDevice;
};

class DeviceStore {
  device = 'desktop';
  orientation = null;

  constructor() {
    makeObservable(this, {
      device: observable,
      orientation: observable,
      updateDeviceType: action,
    });
    this.updateDeviceType();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);
  }

  handleResize = () => {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(this.updateDeviceType, 50);
  };

  updateDeviceType = () => {
    const { device, orientation } = getDeviceType();
    this.device = device;
    this.orientation = orientation;
  };

  dispose() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);
  }
}

const deviceStore = new DeviceStore();
export default deviceStore;
